import { isDefAndNotNull } from '@utils/def';

import { MeasuringUnit } from './enums';

export const MEASURING_UNIT_LABEL: Record<MeasuringUnit, string> = {
  [MeasuringUnit.Percent]: '%',
  [MeasuringUnit.Bps]: 'bps',
  [MeasuringUnit.Dps]: 'dps',
  [MeasuringUnit.Pips]: 'pips',
  [MeasuringUnit.Cash]: 'cash',
};

// Value expressed as a fraction of "percent" for each convertible unit.
// 1% = 100bps, so 1bps = 0.01% and etc
const PERCENT_EQUIVALENT: Partial<Record<MeasuringUnit, number>> = {
  [MeasuringUnit.Percent]: 1,
  [MeasuringUnit.Bps]: 0.01,
};

// Value expressed in dps (points / pipettes, the smallest displayed fraction of a pip).
// 1 pip = 10 dps for every pair (0.0001 vs 0.00001; for JPY pairs 0.01 vs 0.001).
const DPS_EQUIVALENT: Partial<Record<MeasuringUnit, number>> = {
  [MeasuringUnit.Dps]: 1,
  [MeasuringUnit.Pips]: 10,
};

// Units can be converted only inside one family (percent <-> bps, dps <-> pips).
const UNIT_FAMILIES = [PERCENT_EQUIVALENT, DPS_EQUIVALENT];

export const convertMeasuringUnit = (
  value: number,
  fromUnit: MeasuringUnit,
  toUnit: MeasuringUnit,
): number => {
  if (fromUnit === toUnit) return value;

  const family = UNIT_FAMILIES.find(
    (ratios) =>
      isDefAndNotNull(ratios[fromUnit]) && isDefAndNotNull(ratios[toUnit]),
  );

  if (!family) return value;

  return (value * family[fromUnit]!) / family[toUnit]!;
};
